export default () => ({
  MuiDialog: {
    paperWidthSm: {
      maxWidth: '700px',
      maxHeight: '2000px',
      overflow: 'hidden'
    }
  }
})
